import { CUSTOM_BLOTTER_GROUPING, MixpanelEvent, type BlotterGroupingDefinition } from '@talos/kyoko';
import type { ExtraPositionColumns, ExtraUnifiedPositionColumns } from '../types';
import type { UnifiedPosition } from './UnifiedPosition';

type UnifiedGroupings = 'Market' | 'Account' | 'Underlying' | 'Custom';
type GroupablePositionColumns = keyof UnifiedPosition | ExtraPositionColumns | ExtraUnifiedPositionColumns;

export const POSITIONS_UNIFIED_GROUPINGS: BlotterGroupingDefinition<UnifiedGroupings, GroupablePositionColumns>[] = [
  {
    key: 'Market',
    label: 'By Market',
    mobileLabel: 'Market',
    rowGroupColumns: ['market', 'MarketAccount', 'underlying', 'Asset'],
    mixpanelEvent: MixpanelEvent.GroupAccounts,
    buttonDataTestId: 'by-market-grouping',
  },
  {
    key: 'Account',
    label: 'By Account',
    mobileLabel: 'Account',
    rowGroupColumns: ['MarketAccount', 'underlying', 'Asset'],
    mixpanelEvent: MixpanelEvent.GroupAccounts,
    buttonDataTestId: 'by-account-grouping',
  },
  {
    key: 'Underlying',
    label: 'By Underlying',
    mobileLabel: 'Underlying',
    rowGroupColumns: ['underlying', 'Asset', 'MarketAccount'],
    mixpanelEvent: MixpanelEvent.GroupAccounts,
    buttonDataTestId: 'by-underlying-grouping',
  },
  {
    key: CUSTOM_BLOTTER_GROUPING,
    label: 'Custom',
    mobileLabel: 'Custom',
    rowGroupColumns: [],
    buttonDataTestId: 'custom-grouping',
  },
];
